import { useCallback, useContext } from "react";
import { Button, Dropdown, notification } from "@findemdev/maui";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, HeaderActionsContainer } from "./Header.styled";
import { useCreateNewCompanyListMutation } from "../../../../../services/company";
import UserContext from "../../../../../contexts/UserContext";
import { VendorType } from "../../../common/constants";
import { getAppName } from "../../../../../utils/common";
import { APP_NAMES } from "../../../../../types/app";
import { CompanyBuilder } from "../../../../../constants/namingConventions";

const appName = getAppName();

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [createNewCompanyList, { isLoading: isCreateNewListLoading }] =
    useCreateNewCompanyListMutation();
  const userModel = useContext(UserContext);

  const createNewCompanyListHandler = useCallback(
    async (vendor: VendorType) => {
      try {
        const response = await createNewCompanyList({
          joid: userModel.getUser().uid,
          vendor,
          appName,
        }).unwrap();

        const returnTo = encodeURIComponent(
          `${location.pathname}${location.search}`
        );
        navigate(`company-list/${response.data.ref}?returnTo=${returnTo}`);
      } catch (error) {
        console.error("Failed to create new company list: ", error);
        notification.error({
          message: "Failed to create list",
        });
      }
    },
    [userModel, appName, location.pathname, location.search, navigate]
  );

  const handleDropddownButtonClick = useCallback(() => {
    if (appName === APP_NAMES.ESP) {
      createNewCompanyListHandler(VendorType.CRUNCHBASE);
    } else if (appName === APP_NAMES.RRA) {
      createNewCompanyListHandler(VendorType.RRA_PITCHBOOK)
    }
  }, [createNewCompanyListHandler]);

  return (
    <Container>
      <div>
        <h2>{CompanyBuilder.appName}</h2>
        <p>{CompanyBuilder.appDescription}</p>
      </div>
      <HeaderActionsContainer>
        {/* <Button
          type="primary"
          onClick={() => createNewCompanyListHandler(VendorType.RRA_PITCHBOOK)}
          disabled={isCreateNewListLoading}
          loading={isCreateNewListLoading}
          icon={<Icon icon="add" />}
        >
          Create Company List
        </Button> */}
        {appName === APP_NAMES.RRA ?
          <Dropdown.Button
            type="primary"
            onClick={handleDropddownButtonClick}
            disabled={isCreateNewListLoading}
            loading={isCreateNewListLoading}
            menu={{
              items: [
                {
                  label: "Using Findem",
                  key: VendorType.CRUNCHBASE,
                },
              ],
              onClick: ({ key }) =>
                createNewCompanyListHandler(key as VendorType),
            }}
          >
            {CompanyBuilder.button.createNewList.primaryText}
          </Dropdown.Button>
          : <Button
            type="primary"
            onClick={handleDropddownButtonClick}
            disabled={isCreateNewListLoading}
            loading={isCreateNewListLoading}
          >
            {CompanyBuilder.button.createNewList.primaryText}
          </Button>
        }
      </HeaderActionsContainer>
    </Container>
  );
};

export default Header;
